"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const Radio_1 = __importDefault(require("@Components/Radio"));
const default_options_1 = require("@Const/default-options");
const PhoneNumberComponent_1 = require("@Components/PhoneNumberComponent");
const Button_1 = require("@Components/Buttons/Button");
const contexts_1 = require("@App/contexts");
require("./index.scss");
const ConfigurationMFA = (props) => {
    const { createPasswordStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { isEmailMFA, email, phoneCountryCode, phoneAreaCode, phoneNumber, phoneNumberValidation } = createPasswordStore;
    const setMFAType = (data) => {
        const isEmailMFALocal = data.value === 'email';
        createPasswordStore.setIsMFAType(isEmailMFALocal);
        if (isEmailMFALocal) {
            createPasswordStore.setIsConfigMFAValid(true);
        }
    };
    const handleMFAValue = (value, id) => {
        value = value ? value : '';
        createPasswordStore.getValue(value, id);
        createPasswordStore.validatorConfigMFA();
    };
    const submitConfigurationMFA = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        props.setLoading(true);
        yield createPasswordStore.submitConfigurationMFA();
        props.setLoading(false);
    });
    (0, react_1.useEffect)(() => createPasswordStore.validatorConfigMFA(), []);
    return (react_1.default.createElement("div", { className: "global-container" },
        react_1.default.createElement("form", { className: "config-mfa-form", onSubmit: submitConfigurationMFA },
            react_1.default.createElement("h3", null, "Configure account security"),
            react_1.default.createElement("p", null,
                "The MLC Portal requires",
                ' ',
                react_1.default.createElement("strong", null,
                    ' ',
                    "Multi-Factor ",
                    react_1.default.createElement("br", null),
                    " Authentication (MFA)",
                    ' '),
                "to secure your account ",
                react_1.default.createElement("br", null),
                " login. Please choose email or mobile options ",
                react_1.default.createElement("br", null),
                " below:"),
            react_1.default.createElement("div", { className: 'radio-buttons' },
                react_1.default.createElement(Radio_1.default, Object.assign({}, default_options_1.statusMFAOptionsMockProps, { onChange: setMFAType, defaultCheckedId: 2 }))),
            isEmailMFA ? (react_1.default.createElement("p", null,
                "Your account email address will be used for MFA: ",
                react_1.default.createElement("strong", null, email))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "Your account phone will be used for MFA: "),
                react_1.default.createElement(PhoneNumberComponent_1.PhoneNumberComponent, { phoneCountryCode: phoneCountryCode, phoneCountryCodeError: phoneNumberValidation.phoneCountryCode.error, phoneCountryCodeRequired: true, phoneAreaCode: phoneAreaCode, phoneAreaCodeError: phoneNumberValidation.phoneAreaCode.error, phoneAreaCodeRequired: true, phoneNumber: phoneNumber, phoneNumberError: phoneNumberValidation.phoneNumber.error, phoneNumberRequired: true, onChange: handleMFAValue }),
                react_1.default.createElement("p", null, "Please enter a mobile number that can receive text messages. MFA codes will be sent via text to this number."))),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', disabled: !createPasswordStore.isConfigMFAValid || props.loading }, "Update MFA Settings"))));
};
exports.default = (0, mobx_react_1.observer)(ConfigurationMFA);
